// Every path pattern App.jsx (and pages/auth/AuthRoutes.jsx) routes to, written absolute.
// The TEST badge matches the current location against these so its aria-label names the screen
// ("TEST · /events/:eventId"), like the mobile badge names the focused route. App.jsx uses
// <Routes> (not a data router), so useMatches is unavailable and this list is the route config.
// Keep it in step with App.jsx when a route is added; catch-all redirects are left out on purpose.
const ROUTE_PATTERNS = [
  "/auth/login",
  "/auth/signup",
  "/auth/forgot",
  "/auth/verify",
  "/clubs",
  "/clubs/new",
  "/clubs/:clubId",
  "/manage",
  "/manage/:clubId/*",
  "/super",
  "/events",
  "/events/:eventId",
  "/profile",
  "/profile/clubs",
  "/users/:userId",
  "/friends",
  "/friends/find",
  "/partners",
  "/partners/all",
  "/partners/:businessId",
  "/notifications",
  "/settings",
  "/settings/notifications",
  "/chats",
  "/chats/:kind/:chatId",
];

export const ROUTE_OBJECTS = ROUTE_PATTERNS.map((path) => ({ path }));
